import { resolveBullseyeTieGroup } from "./bullseyeTieBreaks";

export function hasBullseyeScoreData(row) {
  // A fired miss is a real zero score. Empty roster placeholders are not results.
  return [row?.shotsFired, row?.totalScore, row?.xCount]
    .some(value => Number.isFinite(Number(value)) && Number(value) > 0);
}

export function rankBullseyeRows(rows = []) {
  const scoreKey = (row) => JSON.stringify([Number(row.totalScore), Number(row.xCount)]);
  const sorted = [...rows]
    .sort((left, right) => {
      const scoredDelta = Number(hasBullseyeScoreData(right)) - Number(hasBullseyeScoreData(left));
      if (scoredDelta) return scoredDelta;
      if (hasBullseyeScoreData(left)) {
        if (right.totalScore !== left.totalScore) return right.totalScore - left.totalScore;
        if (right.xCount !== left.xCount) return right.xCount - left.xCount;
      }
      return String(left.competitorName || "").localeCompare(String(right.competitorName || ""));
    });
  const cohorts = new Map();
  sorted.filter(hasBullseyeScoreData).forEach(row => {
    const key = scoreKey(row);
    cohorts.set(key, [...(cohorts.get(key) || []), row]);
  });
  const ranked = [];
  for (const cohort of cohorts.values()) {
    for (const group of resolveBullseyeTieGroup(cohort)) {
      const rank = ranked.length + 1;
      ranked.push(...group.rows.map(row => ({ ...row, rank, isTied: group.rows.length > 1,
        tieBreakRule: group.decision?.rule || "", tieBreakLabel: group.decision?.label || "",
        tieBreakValue: group.decision ? Math.abs(group.decision.value) : null,
        tiePendingReason: group.pending || "" })));
    }
  }
  return [...ranked, ...sorted.filter(row => !hasBullseyeScoreData(row)).map(row => ({ ...row,
    rank: null, isTied: false, tieBreakRule: "", tieBreakLabel: "", tiePendingReason: "" }))];
}

export function bullseyeAwardCutoff(rows, places) {
  return rankBullseyeRows(rows).filter((row) => row.rank != null && row.rank <= places);
}

export function rankBullseyeParticipationRows(rows = []) {
  return [false, true].flatMap((twentyTwoOnly) => (
    rankBullseyeRows(rows.filter((row) => Boolean(row.twentyTwoOnly) === twentyTwoOnly))
      .map((row) => ({ ...row, participationGroup: twentyTwoOnly ? ".22 Only" : "Standard" }))
  ));
}

export function groupBullseyeDisplayRows(rows = []) {
  return rankBullseyeParticipationRows(rows).map((row, index, ranked) => ({
    ...row,
    groupHeading: index === 0 || ranked[index - 1].participationGroup !== row.participationGroup
      ? `${row.participationGroup} Standings` : undefined,
    podiumRank: row.rank ?? 0,
    rankDisplay: row.rank == null ? "-" : row.isTied ? `T${row.rank}` : ["1st", "2nd", "3rd"][row.rank - 1] || `#${row.rank}`,
  }));
}
